import {ChangeDetectionStrategy, Component} from '@angular/core'
import {Monologic} from '../dialog/monologic.interface'
import {AlternativeCallToAction, SendMessageEvent} from './contact-form-card.types'

@Component({
  template: `
    <cft-dialog [title]="t('contactDialog.title')" *transloco="let t">
      <cft-dialog-content>
        <cft-contact-form-card
          elevated="false"
          [alternativeCallToAction]="props.alternativeCallToAction"
          [dataPrivacyLink]="props.dataPrivacyLink"
          (sendMessage)="props.sendMessage($event)"
        />
      </cft-dialog-content>
    </cft-dialog>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactFormCardDialogComponent implements Monologic<Props> {
  props!: Props

  setData(props: Props): void {
    this.props = props
  }
}

interface Props {
  alternativeCallToAction: AlternativeCallToAction
  dataPrivacyLink: string
  sendMessage: (event: SendMessageEvent) => void
}
